//
//

import { mapActions, mapGetters } from "vuex";
import { uid } from "quasar";
import { required, email } from "vuelidate/lib/validators";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQAvatar from "@/components/Generics/AQAvatar/AQAvatar.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import { PassValidator } from "@/components/Login/PassValidator";
import FabricInput from "@/components/q-fabric-input.vue";
import EditRoleOnUser from "@/components/Admin/RolesAndUsers/EditRolesForUsers/EditRoleOnUser.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQRadio from "@/components/Generics/AQRadio/AQRadio.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";
import AQListBtn from "@/components/Generics/AQButtonsList/AQButtonsList.vue";
import { allowAccessibilityColors, eventBus } from "@/assets/js/appFunc";
import AppAccessPermissions from "../../Application/AppPermissions/AppAccessPermissions.vue";

export default {
    name: "AdminAddEditUser",
    components: {
        AQModal,
        AQAvatar,
        AQInput,
        AQButton,
        AQDropdown,
        FabricInput,
        EditRoleOnUser,
        AppAccessPermissions,
        AQTooltip,
        AQCheckbox,
        AQListBtn,
        AQRadio,
        AQDialog,
        AQCard
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        inEditRow: {
            type: Object,
            default: () => {}
        },
        selectedRoles: {
            type: Array,
            default: () => []
        },
        currentRolesForUser: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            modalValue: true,
            save: {
                label: this.$t("admin.usersAndRoles.permissionsModal.saveBtn"),
                disabled: false
            },
            currentGroupsIds: [],
            userAccessibility: false,
            currentUserId: "",
            localGroups: [],
            inactiveGroups: [],
            hasClose: true,
            hasCancel: false,
            roleListNotEmpty: false,
            avatar: null,
            status: false,
            initialStatus: "ACTIVE",
            isPassword: false,
            passwordFieldType: "password",
            repeatPassword: "",
            currentHovered: null,
            newUserArr: [],
            statusOptsLDAP: [
                { label: this.$t("admin.usersAndRoles.editUserModal.active"), value: "ACTIVE" },
                { label: this.$t("admin.usersAndRoles.editUserModal.inactive"), value: "INACTIVE" }
            ],
            statusOpts: [
                { label: this.$t("admin.usersAndRoles.editUserModal.active"), value: "ACTIVE" },
                { label: this.$t("admin.usersAndRoles.editUserModal.disabled"), value: "DISABLED" }
            ],
            languageOptions: [
                {
                    value: "en",
                    label: this.$t("admin.usersAndRoles.editUserModal.english")
                },
                {
                    value: "ro",
                    label: this.$t("admin.usersAndRoles.editUserModal.romanian")
                }
            ],
            currentSelectedPermission: {},
            currentUserPermissions: [],
            manualPermissions: "",
            rolesListCurrentUser: [],
            selectedGroupsFromModal: [],
            userEditData: {
                id: "",
                code: "",
                avatarPath: "",
                type: "",
                email: "",
                firstName: "",
                language: "",
                lastName: "",
                password: "",
                phone: "",
                status: "",
                systemType: "",
                sourceType: "",
                title: ""
            },
            initialAvatarPath: "",
            canBeDeleted: true,
            initialEmail: "",
            emailDuplicate: false,
            phoneError: false,
            hasSave: true,
            readonlyUser: true,
            userLanguage: "",
            emptyFirstName: false,
            emptyLastName: false,
            emptyEmail: false,
            submitStatus: null,
            emailOk: true,
            addPermissionModal: false,
            addRoleModal: false,
            group: [],
            savedRolesToNewUser: [],
            savedPermissionsToNewUser: [],
            userPermissions: [],
            dirty: false,
            processDefinitionsRoles: [],
            inheritedPermissions: [],
            radioDisabled: false,
            disabledWarning: false,
            hiddenBtnsFromList: ["edit", "download", "copy", "more"],
            errorMsgAdmin: ""
        };
    },
    computed: {
        ...mapGetters("admin", [
            "roleList",
            "roleTableData",
            "loadingRoles",
            "getRoleDataByID",
            "userList",
            "getRolesUserList",
            "getCurrentRoles",
            "getCurrentPermissions",
            "getPermissionsRoleList",
            "getUsersRoleList",
            "getCurrentUsers",
            "getUsersforEdit",
            "getProcessDetailsAndRoles"
        ]),
        ...mapGetters("apps", ["apps"]),
        ...mapGetters("main", ["getShowAccessibilityOption"]),
        ...mapGetters("userProfile", ["userDataDetails"]),

        validatePass() {
            let msg = "";
            if (!this.$v.userEditData.password.required || !this.$v.userEditData.password.minLength || !this.$v.userEditData.password.PassValidator) {
                msg = this.$t("admin.usersAndRoles.manualAddModal.passwordRequirements");
            }
            return msg;
        },
        userstatusOpts() {
            return this.userEditData && this.userEditData.realmId ? this.statusOptsLDAP : this.statusOpts;
        },
        validateRepeatPass() {
            let msg = "";
            if (!this.$v.repeatPassword.required) {
                msg = this.$t("login.confirmPass");
            } else if (!this.$v.repeatPassword.matchPass) {
                msg = this.$t("login.resetErr");
            }
            return msg;
        },
        dontChangePass() {
            return !!(this.userEditData && (this.userEditData.status === "INACTIVE" || this.userEditData.status === "DISABLED"));
        },
        isReadonly() {
            return !!(this.userEditData && (this.userEditData.realmId || this.userEditData.type === "TSAMLUSR" || this.userEditData.type === "TOPENIDUSR"));
        },
        readonlyLDAP() {
            return !!(this.userEditData && this.userEditData.realmId);
        },
        isEditMode() {
            return !!this.inEditRow;
        },
        getModalTitle() {
            return this.isEditMode ? this.$t("admin.usersAndRoles.editUserModal.title") : this.$t("admin.usersAndRoles.manualAddModal.title");
        },
        defaultLanguage() {
            const defaultValue = (!this.userEditData.language || this.userEditData.language === "english"
            || this.userEditData.language === "en-us") ? "en" : null;
            return defaultValue || (typeof this.userEditData.language === "string" ? this.userEditData.language : this.userEditData.language[0].value);
        }
    },
    watch: {
        inEditRow: {
            handler(newValue) {
                if (newValue) {
                    if (newValue.email) {
                        this.initialEmail = newValue.email;
                    }
                    this.userEditData = { ...newValue, password: newValue.password || "" };
                    if (!this.userEditData.status) {
                        this.userEditData.status = this.initialStatus;
                    }
                    this.initialAvatarPath = this.userEditData.avatarPath;
                    this.userAccessibility = this.userEditData.colorsAccessibility;
                    this.currentUserId = newValue.id;
                    this.getPermissionsForUser({
                        userId: newValue.id,
                        permissionsList: this.getPermissionsRoleList
                    });
                }
            },
            immediate: true
        },
        getCurrentPermissions: {
            handler(newValue) {
                this.currentUserPermissions = this.getAllDetailsPermissions(
                    newValue,
                    this.apps
                );
                this.manualPermissions = this.setManualPermissions(newValue);
            },
            immediate: true
        },
        getCurrentRoles: {
            handler(newValue) {
                if (this.roleList && this.roleList.length && !this.roleListNotEmpty) {
                    this.roleListNotEmpty = (newValue && newValue.length);
                    this.setRolesForUser(newValue);
                }
            },
            immediate: true
        },
        roleList: {
            handler(value) {
                if (value && value.length && !this.roleListNotEmpty) {
                    this.roleListNotEmpty = (this.getCurrentRoles && this.getCurrentRoles.length);
                    this.setRolesForUser(this.getCurrentRoles);
                }
            },
            immediate: true
        },
        userEditData: {
            handler() {
                this.dirty = true;
                if (this.userEditData.status === "INACTIVE" || this.userEditData.status === "DISABLED") {
                    this.isPassword = false;
                    this.userEditData.password = "";
                    this.repeatPassword = "";
                }
            },
            deep: true
        },
        getProcessDetailsAndRoles: {
            handler(newValue) {
                if (newValue) {
                    this.processDefinitionsRoles = newValue.directPermissions || [];
                    this.inheritedPermissions = newValue.inheritedPermissions || [];
                }
            },
            immediate: true
        }
    },
    validations: {
        userEditData: {
            firstName: {
                required
            },
            lastName: {
                required
            },
            email: {
                required,
                email
            },
            password: {
                required(v) {
                    if (!this.isPassword) {
                        return true;
                    }
                    return required(v);
                },
                PassValidator() {
                    if (!this.isPassword) {
                        return true;
                    }
                    return PassValidator(this.userEditData.password);
                },
                minLength(v) {
                    if (!this.isPassword) {
                        return true;
                    }
                    return (v && v.length >= 8);
                }
            }
        },
        repeatPassword: {
            required(v) {
                if (!this.isPassword) {
                    return true;
                }
                return required(v);
            },
            matchPass(v) {
                if (!this.isPassword) {
                    return true;
                }
                return v === this.userEditData.password;
            }

        }
    },
    created() {
        if (!this.roleList.length || !this.roleList) {
            this.getRoleList();
        }
        if (!this.userList.length || !this.userList) {
            this.getUsersList();
        }
        if (this.userEditData.language) {
            this.userLanguage = this.languageOptions.filter(elem => this.userEditData.language === elem.value);
        }
    },
    beforeDestroy() {
        this.$store.commit("admin/setRolesUserList");
        this.$store.commit("admin/setProcessDetailsAndRoles");
    },
    methods: {
        ...mapActions("apps", ["actGetUserSystemPermissions"]),
        ...mapActions("admin", [
            "getRoleList",
            "editRole",
            "getUsersList",
            "createNewUser",
            "addRolesToUser",
            "getRolesForUser",
            "getPermissionsForUser",
            "actCreateUpdateUser"
        ]),
        actionsDlg($event) {
            if ($event === "save") {
                if (this.radioDisabled) {
                    this.disabledWarning = true;
                } else {
                    this.modalSave();
                }
            } else {
                this.modalValue = false;
                this.$emit("input");
            }
        },
        modalSave() {
            this.$v.$touch();
            if (!(!this.isReadonly && (this.$v.$invalid || this.emailDuplicate || this.phoneError
                || (this.isPassword && this.$v.userEditData.password.$invalid && this.$v.repeatPassword.$invalid)))) {
                this.editUser();
                this.modalValue = false;
                this.$emit("input");
                eventBus.$emit("renderMenuFromAdmin");
            }
        },
        setAvatar(item) {
            let type;
            if (item.sourceType === "AD" || item.systemType === "EXTERNAL") {
                type = (item.active || item.status) ? "externalGroup" : "externalDisabledGroup";
            } else if (item.systemType === "SYSTEM") {
                type = (item.active || item.status) ? "system" : "applicationDisabled";
            } else if (item.systemType === "APPLICATION") {
                type = (item.active || item.status) ? "applicationSpecific" : "applicationDisabled";
            } else {
                type = (item.active || item.status) ? "platform" : "applicationDisabled";
            }
            return type;
        },
        setUserType(value) {
            let type;
            if (value.systemType === "TOAUTHUSR") {
                type = "systemExternalUser";
            } else if (value.systemType === "TSYS") {
                type = "systemInternalUser";
            } else {
                type = (value.sourceType === "AD" || value.type === "TSAMLUSR" || value.type === "TOPENIDUSR" || value.realmId)
                    ? "externalUser" : "userPlatform";
            }
            return type;
        },
        uploadUserPicture(e) {
            const found = /jpg|jpeg|png/.test(e);
            if (!found) {
                this.$q.notify({
                    message: this.$t("userProfile.uploadedProfileImageTypeError"),
                    type: "negative"
                });
            } else {
                this.userEditData.avatarPath = e;
            }
        },
        showDeleteIcon(role, index) {
            this.canBeDeleted = (role.groupId !== "6312ce15-5158-4724-85db-7fe7aa98e0f9");
            this.currentHovered = index;
        },
        hideDeleteIcon() {
            this.canBeDeleted = true;
            this.currentHovered = null;
        },
        afterHide() {
            this.$store.commit("admin/setRolesUserList", { response: [] });
            this.$emit("input", false);
        },
        editUser() {
            let langToSend = this.defaultLanguage;
            if (this.userEditData.language && typeof this.userEditData.language === "object") {
                langToSend = this.userEditData.language[0].value;
            } else if (this.userLanguage && this.userLanguage.length) {
                langToSend = this.userLanguage[0].value;
            }
            const payload = {
                ...this.getExtraProps(),
                avatarPath: this.userEditData.avatarPath,
                email: this.userEditData.email,
                username: this.isReadonly ? (this.userEditData.email || this.userEditData.username) : this.userEditData.email,
                firstName: this.userEditData.firstName,
                lastName: this.userEditData.lastName,
                password: this.isPassword ? this.userEditData.password : "",
                phone: this.userEditData.phone,
                position: this.userEditData.position,
                department: this.userEditData.department,
                language: langToSend,
                colorsAccessibility: this.userAccessibility,
                processDetailsAndRoles: this.getProcessDefinitionsRoles(),
                groups: this.returnAssignedRoles()
            };
            this.actCreateUpdateUser(payload).then(() => {
                if (payload.id && payload.id === this.userDataDetails.id) {
                    this.actGetUserSystemPermissions();
                    localStorage.setItem("accessibility", this.userAccessibility);
                    const hasAccFeature = localStorage.getItem("accessibilityFeature");
                    allowAccessibilityColors(this.userAccessibility && hasAccFeature === "true");
                }
                this.$toast.showNotify({
                    type: "success",
                    message: payload.addNewUser ? this.$t("admin.usersAndRoles.editUserModal.createdSuccessfully")
                        : this.$t("admin.usersAndRoles.editUserModal.savedSuccessfully")
                });
            }).catch((err) => {
                if (err.response.status === 409) {
                    if (err.response.data.error === "Cannot change another admin's password!") {
                        this.errorMsgAdmin = this.$t("admin.usersAndRoles.editUserModal.errorAdmin");
                        this.$toast.showNotify({
                            type: "error",
                            message: this.errorMsgAdmin
                        });
                    }
                }
            });
        },
        getExtraProps() {
            let addProps = {};
            if (this.isEditMode) {
                addProps = { id: this.userEditData.id, status: this.userEditData.status, editType: true };
            } else {
                addProps = { code: uid(), addNewUser: true };
            }
            return addProps;
        },
        getProcessDefinitionsRoles() {
            const permissions = this.processDefinitionsRoles.map(element => ({
                targetId: element.id || element.targetId,
                roles: (element.permissions || element.roles).filter(permission => permission.code !== "OWNER"),
                permissionType: "PROCESS_DEFINITION"
            }));

            return permissions;
        },
        returnAssignedRoles() {
            let groupsToSend = [];
            groupsToSend = this.localGroups.map(elem => ({
                groupId: elem.groupId || elem.id,
                isManager: elem.isManager || false
            }));
            return groupsToSend.concat(this.inactiveGroups);
        },
        addPermission() {
            this.addPermissionModal = true;
        },
        addPermissionsClosed() {
            this.currentSelectedPermission = {};
        },
        addRoleOnUser() {
            this.currentRolesIds = this.localGroups.map(element => element.groupId || element.id);
            this.addRoleModal = true;
        },
        addRoleClosed() {
            this.addRoleModal = false;
        },
        modalClosed(roles) {
            if (roles && roles.length) {
                this.localGroups = [...this.localGroups, ...roles];
            }
            setTimeout(() => {
                this.addRoleModal = false;
            }, 0);
        },
        editPermission(permission) {
            if (!this.isReadonly) {
                this.currentSelectedPermission = permission;
                this.addPermissionModal = true;
            }
        },
        deletePermission(index) {
            const dataPermissions = [...this.getCurrentPermissions];
            dataPermissions.splice(index, 1);
            this.$store.commit("admin/setPermissionsRoleList", {
                response: dataPermissions
            });
        },
        setRolesForUser(newValue) {
            this.rolesListCurrentUser = this.getAssignedRoles(newValue);
            this.localGroups = JSON.parse(JSON.stringify(this.rolesListCurrentUser.filter(elem => elem && elem.active)));
            this.inactiveGroups = this.rolesListCurrentUser.filter(elem => !elem || !elem.active);
        },
        getAllDetailsPermissions(data, app) {
            const dynamicPermissionsData = data.filter(elem => elem.permissionType !== "OTHER");
            return dynamicPermissionsData.map(element => {
                const newElem = JSON.parse(JSON.stringify(element));
                const selectedApp = app.filter(elApp => elApp.id === newElem.targetId)[0];
                let permissionsType = [];
                permissionsType = newElem.permission ? newElem.permission.split(":") : null;
                newElem.imageId = selectedApp && selectedApp.imageId ? selectedApp.imageId : "";
                newElem.permissionLevels = permissionsType ? permissionsType[permissionsType.length - 1].split(",") : null;
                newElem.name = selectedApp && selectedApp.name ? selectedApp.name : "";
                newElem.publishStatus = selectedApp && selectedApp.publishStatus
                    ? selectedApp.publishStatus
                    : "";
                return newElem;
            });
        },
        setManualPermissions(data) {
            const manualPermissionsData = data.filter(elem => elem.permissionType === "OTHER") || [];
            let manualModel = "";
            manualPermissionsData.forEach(element => {
                manualModel += manualModel
                    ? `,${element.permission}`
                    : element.permission;
            });
            return manualModel;
        },
        getAssignedRoles(roles) {
            return roles.map(element => {
                const newElem = JSON.parse(JSON.stringify(element));
                const currentRole = this.roleList.filter(role => role.id === newElem.groupId)[0];
                if (currentRole && currentRole.active) {
                    const { name, sourceType, systemType, active, members } = currentRole;
                    newElem.name = name || "";
                    newElem.sourceType = sourceType || "";
                    newElem.systemType = systemType || "";
                    newElem.active = active;
                    newElem.nrOfGroups = members && members[0] && members[0].nrOfGroups ? members[0].nrOfGroups : 0;
                    newElem.nrOfUsers = members && members[0] && members[0].nrOfUsers ? members[0].nrOfUsers : 0;
                }
                return newElem;
            });
        },
        getImagePath() {
            let path = null;
            if (this.initialAvatarPath) {
                if (this.initialAvatarPath === this.userEditData.avatarPath) {
                    path = `/identity/tenants/users/image/${this.userEditData.id}/m`;
                } else {
                    path = this.userEditData.avatarPath;
                }
            } else if (this.userEditData.avatarPath) {
                path = this.userEditData.avatarPath;
            }
            return path;
        },
        deleteRole(index) {
            this.localGroups.splice(index, 1);
        },
        checkPhone() {
            if (this.userEditData && this.userEditData.phone) {
                const regex2 = /^[+][0-9]{1,15}$/;
                this.phoneError = !regex2.test(this.userEditData.phone);
            }
        },
        emailValidation() {
            this.$v.userEditData.email.$touch();
        },
        checkEmail() {
            if (this.userEditData && this.userEditData.email) {
                let emailAlreadyExist = false;
                for (let i = 0; i < this.userList.length; i++) {
                    if (
                        this.userList[i].email.toLowerCase() === this.userEditData.email.toLowerCase()
            && this.userEditData.email.toLowerCase() !== this.initialEmail.toLowerCase()
                    ) {
                        emailAlreadyExist = true;
                        break;
                    }
                }
                this.emailDuplicate = emailAlreadyExist;
            } else {
                this.emailDuplicate = false;
            }
        },
        radioInput(status) {
            this.radioDisabled = status === "DISABLED";
        }
    }
};
